import { render, staticRenderFns } from "./EnterDeliveryAddress.vue?vue&type=template&id=2cdd1726"
import script from "./EnterDeliveryAddress.vue?vue&type=script&lang=js"
export * from "./EnterDeliveryAddress.vue?vue&type=script&lang=js"
import style0 from "./EnterDeliveryAddress.vue?vue&type=style&index=0&id=2cdd1726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports